import classNames from "classnames";

export default {
  /**
   *
   */
  props: ["head", "body"],

  /**
   *
   * @returns {{open: boolean}}
   */
  data() {
    return { open: false };
  },

  /**
   *
   */
  methods: {
    toggleOpen() {
      this.open = !this.open;
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const icnClass = classNames(
      "mdi text-teal-900 mr-3 leading-tight", {
        'mdi-plus-circle-outline': !this.open,
        'mdi-minus-circle-outline': this.open
      }
    );

    return (
      <div class="bg-white p-3 lg:p-6 mb-1">
        <div class="flex lg:items-center cursor-pointer select-none" onClick={this.toggleOpen}>
          <i class={icnClass}></i>
          <p class="font-bold text-sm lg:text-base text-gray-800">
            {this.head}
          </p>
        </div>
        <transition
          name="custom-classes-transition"
          enter-active-class="transition-all transform ease-out duration-100"
          enter-class="opacity-0 scale-95 max-h-0"
          enter-to-class="opacity-100 scale-100 max-h-screen"
          leave-active-class="transition-all transform ease-in duration-75"
          leave-class="opacity-100 scale-100 max-h-screen"
          leave-to-class="opacity-0 scale-95 max-h-0"
        >
          {this.open && (
            <p class="text-sm lg:text-base py-3 mx-6 pl-1 text-gray-800 origin-top overflow-hidden leading-relaxed" domPropsInnerHTML={this.body}>
            </p>
          )}
        </transition>
      </div>
    );
  }
};
